import { Typography } from '@euler/app/components/typography';
import { BottomPanel } from '@euler/components/BottomPanel';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import {
  kCoachingWeeklyGoalMax,
  kCoachingWeeklyGoalMin,
} from '@euler/model/coaching-progress';
import { memo, useEffect, useState } from 'react';
import { Pressable, View } from 'react-native';
import { CardNotice } from '../../../ai-suite/components/ChatCard';
import { PrimaryButton } from '../../../ai-suite/components/PrimaryButton';
import { aiColors } from '../../../ai-suite/theme';

const kChoices = Array.from(
  { length: kCoachingWeeklyGoalMax - kCoachingWeeklyGoalMin + 1 },
  (_, i) => kCoachingWeeklyGoalMin + i,
);

/** 每周目标: one to seven practices a week. */
export const GoalSheet = memo(
  ({
    visible,
    current,
    saving,
    onClose,
    onSave,
  }: {
    visible: boolean;
    current: number;
    saving: boolean;
    onClose: () => void;
    /** False when it did not save. */
    onSave: (goal: number) => Promise<boolean>;
  }) => {
    const { rpx } = useResponsiveContext();
    const [goal, setGoal] = useState(current);
    const [failed, setFailed] = useState(false);
    useEffect(() => {
      if (!visible) return;
      setGoal(current);
      setFailed(false);
    }, [current, visible]);
    return (
      <BottomPanel visible={visible} onClose={onClose} fitContent>
        <View style={{ padding: rpx(20), gap: rpx(16) }}>
          <Typography.Text size={rpx(16)} bold color={aiColors.foreground}>
            每周练几次？
          </Typography.Text>
          <View style={{ flexDirection: 'row', gap: rpx(8) }}>
            {kChoices.map(n => (
              <Pressable
                key={n}
                onPress={() => setGoal(n)}
                accessibilityRole="button"
                accessibilityState={{ selected: n === goal }}
                style={{
                  flex: 1,
                  alignItems: 'center',
                  paddingVertical: rpx(10),
                  borderRadius: rpx(8),
                  borderWidth: 1,
                  borderColor: n === goal ? aiColors.primary : aiColors.border,
                  backgroundColor:
                    n === goal ? aiColors.secondary : aiColors.card,
                }}
              >
                <Typography.Text
                  size={rpx(15)}
                  bold={n === goal || undefined}
                  color={n === goal ? aiColors.primary : aiColors.foreground}
                >
                  {String(n)}
                </Typography.Text>
              </Pressable>
            ))}
          </View>
          {failed ? (
            <CardNotice tone="danger" text="没保存上，请再试一次。" />
          ) : null}
          <PrimaryButton
            title={`每周 ${goal} 次`}
            loading={saving}
            onPress={async () => {
              if (await onSave(goal)) onClose();
              else setFailed(true);
            }}
          />
        </View>
      </BottomPanel>
    );
  },
);
